import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import { Modal, Button } from "react-bootstrap";
import axios from 'axios';
import apiUrl from '../../apiUrlConstant';
import styled from 'styled-components';
import datatableOptions from '../../layout/datatableConstants';
import moment from 'moment';
import { debounce } from 'lodash';
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import SimpleReactValidator from "simple-react-validator";
import { faChevronRight, faCogs, faPen, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AddSubStage from './SubStageAdd';
import EditSubStage from './SubStageEdit';
import { getUserCategory, numberFormat } from "../../utils/index";

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #003970;
`;

const statusOptions = [
  { value: '', label: 'All Stage' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' }
];

class TaskList extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

    this.state = {
      subStageLists: [],
      totalRows: 10,
      loading: false,
      filterText: '',
      statusFilter: '', // Added for status filter
      perPage: 10,
      page: 1,
      editModalFlag: false,
      actieveId: null,
      activeTaskData: {},
      editType: '',
      addSection:'',
      showModal: false,
      modalForm:''
    };

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.fetchTasks = this.fetchTasks.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.openModal = this.openModal.bind(this);
    this.handleStatusFilterChange = this.handleStatusFilterChange.bind(this); // Added for status filter
    this.closeTaskModel = this.closeTaskModel.bind(this);
  }

  componentDidMount() {
    this.fetchTasks();
  }

  handlePageChange(page) {
    this.fetchTasks(this.state.filterText, this.state.statusFilter, page);
  }

  closeTaskModel() {
    this.setState({ showModal: false });
    this.fetchTasks();
  }

  handlePerRowsChange(newPerPage, page) {
    this.setState({ perPage: newPerPage });
    this.fetchTasks(this.state.filterText, this.state.statusFilter, page);
  }

  clearFilter() {
    this.setState({ filterText: '', statusFilter: '' }, () => {
      this.fetchTasks();
    });
  }

  handleFilter(event) {
    const filterValue = event.target.value;
    this.setState({ filterText: filterValue }, () => {
      debounce(() => {
        this.fetchTasks(this.state.filterText, this.state.statusFilter, this.state.page);
      }, 300)();
    });
  }

  handleStatusFilterChange(event) {
    const statusValue = event.value;
    this.setState({ statusFilter: statusValue }, () => {
      this.fetchTasks(this.state.filterText, this.state.statusFilter, this.state.page);
    });
  }

  openModal() {
    this.setState({ showModal: true });
  }

  fetchTasks(filterText = '', statusFilter = '', page = 1) {
    this.setState({ loading: true });

    axios
      .get(`${apiUrl.apiUrl.url}/leads/sub-stage-list`, {
        params: {
          per_page: this.state.perPage,
          page: page,
          filter: filterText,
          status: statusFilter, // Pass the status filter value to the API
        },
      })
      .then((response) => {
        if (response.data.status === 'success') {
          this.setState({
            subStageLists: response.data.data,
            totalRows: response.data.total,
            loading: false,
            page: page,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  render() {

    const columns = [
      {
        name: 'Stage',
        selector: 'stage',
        sortable: true,
        cell: (record) => (
          record.stage.charAt(0).toUpperCase() + record.stage.slice(1)
        )
      },
      {
        name: 'Sub Stage',
        selector: 'title',
        sortable: true,
        cell: (record) => (
            record.title.charAt(0).toUpperCase() + record.title.slice(1)
        ),
      },
      {
        name: 'Winning Probability Percentage(%)',
        selector: 'winning_probability',
        sortable: true,
        cell: (record) => (
          record.winning_probability ? numberFormat(record.winning_probability) : ''
        )
      },
      {
        name: 'Status',
        selector: 'status',
        sortable: true,
        cell: (record) => (
          record.status && record.status=='1' ? 'Enable' : 'Disable'
        )
      },
      {
        name: 'Sequence Number',
        selector: 'sequence',
        sortable: true,
        cell: (record) => (
          record.sequence ? numberFormat(record.sequence) : ''
        )
      },
      {
        name: 'Added On',
        selector: 'created_on',
        sortable: true,
        cell: (record) => moment(record.created_on).format('DD-MMM-YYYY'),
      },
      {
        name: 'Updated On',
        selector: 'updated_on',
        sortable: true,
        cell: (record) => record.updated_on?moment(record.updated_on).format('DD-MMM-YYYY'):'',
      },
      {
        name: 'Action',
        cell: (record) => (
          record.status !== 'completed' && (
            <div className='d-flex align-items-center gap-2'>
              <button
                title='Edit Sub Stage'
                className='bg-white'
                onClick={() => {
                  this.setState(
                    {
                        showModal: true,
                        actieveId: record.id,
                        modalForm: 'edit',
                    },
                    // () => {
                    //   const activeTaskData = this.state.subStageLists.find(item => item.id === this.state.actieveId);
                    //   activeTaskData.reminder_date_time = activeTaskData.reminder_date_time ? activeTaskData.reminder_date_time : '';
                    //   activeTaskData.due_date = activeTaskData.due_date ? moment(activeTaskData.due_date).format('YYYY-MM-DD') : '';
                    //   this.setState({ activeTaskData });
                    // }
                  );
                }}
              >
                <FontAwesomeIcon icon={faPen} color='orange' />
              </button>
            </div>
          )
        )
      },
    ];

    return (
      <>
        <div className="parentContainer">
          <div className="absoluteItemForTopBar">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li>
                  <Link to="/leads" style={{ color: "#000", textDecoration: "none" }}>Lead</Link>
                </li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>
                  <Link to="#">Master</Link>
                </li>
                <li>
                  <Link to="#">Sub Stage</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="masterContainer tableFirstElementPadding p-0">
            <div className='unitFormContainerNew '>
              <div className="row m-0">
                <div className="col-8 ps-0">
                  <div className="d-flex align-items-center gap-2">
                    {/* <TextField type="text"/> */}
                    <input placeholder="Filter by Name" type="text" value={this.state.filterText} onChange={this.handleFilter} />
                    <Select
                      value={this.state.statusValue}
                      onChange={this.handleStatusFilterChange}
                      options={statusOptions}
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                    />

                  </div>
                </div>
                <div className="col-4 d-flex justify-content-end pe-0 align-items-center">
                    <button className="create_lease_landlord" onClick={()=>{ this.setState({showModal: true, modalForm:'add'})}} >Add Sub Stage</button>
                </div>
              </div>
            </div>

            <div className="tableContainer">
              <DataTable
                title=""
                columns={columns}
                data={this.state.subStageLists}
                customStyles={datatableOptions.datatableOptions.customStyle}
                progressPending={this.state.loading}
                pagination
                paginationServer
                paginationTotalRows={this.state.totalRows}
                onChangeRowsPerPage={this.handlePerRowsChange}
                onChangePage={this.handlePageChange}
                paginationComponentOptions={datatableOptions.datatableOptions.paginationOptions}
              />
            </div>

            <Modal show={this.state.showModal} className='customModalFroTaskAndComment' onHide={() => this.setState({ showModal: false })} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>{this.state.modalForm === "add" ? "Add sub stage" : "Edit sub stage"} </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.modalForm==='add'? (
                    <AddSubStage closeModal={this.closeTaskModel} />
                ):(
                    <EditSubStage closeModal={this.closeTaskModel} id={this.state.actieveId} />
                )
                }
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </>
    );
  }
}

export default TaskList;
